export default __webpack_public_path__ + "static/media/ethtraderdonuts.cf431c69.png";